export default __webpack_public_path__ + "static/reparerUnSacEnCuir.1-2d41be7d0ba87da5ee10ef3ee38ee860.jpg";